import React from 'react';
import _ from 'lodash';
import { useQuery, useMutation } from 'react-fetching-library';
import { Box, Modal, Card, CardContent, CardHeader, Checkbox, IconButton, List, ListItem, ListItemIcon, ListItemText, TextField, Stack, Typography, Button, OutlinedInput } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { getOrderFieldsAction, getEmployeeApplicationFields, getEmployeeFields, getSpreadsheetTemplate, updateSpreadsheetTemplate } from '../../../services/request';
import toast from 'react-hot-toast';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};

export default function EditSpreadsheetTemplateModal({ open, handleClose, templateId, tab = '' }) {
  const [name, setName] = React.useState('');
  const [fields, setFields] = React.useState([]);
  const [checked, setChecked] = React.useState([]);
  const { loading: stLoading, payload: stPayload, error: stError } = useQuery(getSpreadsheetTemplate(templateId));
  const { mutate } = useMutation(updateSpreadsheetTemplate);

  let getFieldsRequest = getOrderFieldsAction;
  if (tab == 'employees') {
    getFieldsRequest = getEmployeeFields;
  } else if (tab == 'applications') {
    getFieldsRequest = getEmployeeApplicationFields;
  }
  const { loading, payload, error } = useQuery(getFieldsRequest());

  const handleNameChange = e => setName(e.target.value);

  const handleToggle = value => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const handleCheckAll = () => setChecked(fields.map((field, index) => index));

  const handleRenumberPostions = () => setFields(prev => prev.map((field, index) => ({ ...field, position: index + 1 })));

  const handleAlignWidth = () => setFields(prev => prev.map(field => ({ ...field, width: 15 })));

  const handleWidthChange = (e, index) => {
    const value = _.isNaN(parseInt(e.target.value)) ? '' : parseInt(e.target.value);

    setFields(prev => prev.map((field, i) => i === index ? { ...field, width: value } : field));
  };

  const handlePositionChange = (e, index) => {
    const value = _.isNaN(parseInt(e.target.value)) ? '' : parseInt(e.target.value);

    setFields(prev => prev.map((field, i) => i === index ? { ...field, position: value } : field));
  };

  const handleSubmit = async () => {
    const data = fields.filter((field, index) => checked.indexOf(index) !== -1);
    const { error: mutateError } = await mutate(templateId, { 'template_name': name, 'template_data': { data } });
    if (!mutateError) {
      handleClose();
      toast.success('Szablon został zmieniony');
    } else {
      toast.error('Nie udało się edytować szablonu');
    }
  };


  React.useEffect(() => {
    if (!error && !loading && !stError && !stLoading) {
      const checked = [];

      const result = payload.result.map((field, index) => {
        const found = stPayload.template_data.data.find(element => element.name === field.name);

        if (!_.isNil(found)) {
          checked.push(index);

          return found;
        }

        return { ...field, width: 15, position: index + 1 };

      });
      setName(stPayload.template_name);
      setFields(result);
      setChecked(checked);
    }
  }, [loading, stLoading]);

  return (
    <Modal open={open} onClose={handleClose}>
      <Card sx={{ ...style, height: '90vh', minWidth: '1100px', display: 'flex', flexDirection: 'column' }}>
        <CardHeader
          title="Stwórz szablon"
          action={
            <IconButton color="primary" onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          }
          sx={{ textAlign: 'center' }}
        />
        <CardContent sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
          <Box sx={{ flex: '0.1' }}>
            <TextField fullWidth label="Nazwa szablonu" value={name} onChange={handleNameChange}></TextField>
          </Box>
          <List sx={{ flex: '0.7', overflow: 'auto' }}>
            {fields.map((field, index) => (
              <ListItem key={index} >
                <ListItemIcon>
                  <Checkbox
                    edge="start"
                    onChange={handleToggle(index)}
                    checked={checked.indexOf(index) !== -1}
                  />
                </ListItemIcon>
                <ListItemText primary={field.verbose_name} />
                <Stack direction="row" spacing={4}>
                  <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
                    <Typography variant="subtitle2">Szerokość: </Typography>
                    <OutlinedInput value={field.width} onChange={e => handleWidthChange(e, index)} type="number"></OutlinedInput>
                  </Stack>
                  <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
                    <Typography variant="subtitle2">Pozycja: </Typography>
                    <OutlinedInput value={field.position} onChange={e => handlePositionChange(e, index)} type="number"></OutlinedInput>
                  </Stack>
                </Stack>
              </ListItem>
            ))}
          </List>
          <Stack sx={{ flex: '0.15' }} direction="column" alignItems="center" justifyContent="center" spacing={2}>
            <Stack direction="row" spacing={2}>
              <Button variant="outlined" onClick={handleCheckAll}>Zaznacz wszystkie</Button>
              <Button variant="outlined" onClick={() => setChecked([])}>Odznacz wszysykie</Button>
              <Button variant="outlined" onClick={handleRenumberPostions}>Renumeruj pozycje</Button>
              <Button variant="outlined" onClick={handleAlignWidth}>Wyrównaj szerokości</Button>
            </Stack>
            <Button variant="contained" onClick={handleSubmit} disabled={name.trim().length === 0 || checked.length === 0}>Edytuj szablon</Button>
          </Stack>
        </CardContent>
      </Card>
    </Modal>);
};
